/**
 * Adjuntos de las compras del Carrito de Compras General (bucket MinIO "compras").
 */
import { UPLOAD_URL } from '../../config';

const token = () => localStorage.getItem('tuvi_token') || '';

/** Sube un archivo y devuelve { archivo_key, nombre, tamano }. */
export async function subirArchivoCompra(file) {
  const mes = new Date().toISOString().slice(0, 7);
  const fd = new FormData();
  fd.append('archivo', file);
  const r = await fetch(`${UPLOAD_URL}/catalogo/upload?prefix=${encodeURIComponent(`compras/${mes}/`)}&bucket=compras&unico=1`, {
    method: 'POST', headers: { Authorization: `Bearer ${token()}` }, body: fd,
  });
  const d = await r.json().catch(() => ({}));
  const f = d?.files?.[0];
  if (!r.ok || !f?.key) throw new Error(d?.message || `No se pudo subir "${file.name}"`);
  return { archivo_key: f.key, nombre: file.name, tamano: file.size };
}

/** URL para ver (o descargar) un adjunto de compra. */
export const urlArchivoCompra = (key, descargar = false) =>
  `${UPLOAD_URL}/compra-archivo/${String(key).split('/').map(encodeURIComponent).join('/')}?token=${encodeURIComponent(token())}${descargar ? '&descargar=1' : ''}`;

/** Copia el archivo como soporte de la factura en Gestión de Pagos (igual que la entrada de bodega). */
export async function adjuntarAFactura(facturaId, file) {
  const fd = new FormData();
  fd.append('factura_id', facturaId);
  fd.append('archivo', file);
  await fetch(`${UPLOAD_URL}/factura`, { method: 'POST', headers: { Authorization: `Bearer ${token()}` }, body: fd });
}

export const money = (v) => '$ ' + Math.round(Number(v || 0)).toLocaleString('es-CO');
export const hoyISO = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
};
